import React from 'react';
import classnames from 'classnames';
import styles from './Checkbox.module.css';

interface Props {
  id: string;
  value: boolean;
  label: string | JSX.Element;
  onChange: (value: boolean) => void;
  isRequired?: boolean;
}

const Checkbox = ({ id, value, label, onChange, isRequired }: Props) => {
  const handleChange = () => onChange(!value);

  return (
    <div className={styles.wrap}>
      <input className={styles.checkbox} type="checkbox" name={id} id={id} value={value ? 1 : 0} onChange={handleChange}/>
      <label className={classnames(styles.label, { [styles.required]: isRequired })} htmlFor={id}>{label}</label>
    </div>
  )
}

export default Checkbox;
